export class Log {

    firstName: string
    lastName: string
    userID: string
    timestamp: any
    details: string
    message: string
    id?: string 

  constructor(data: any, id?: string) {
    this.firstName = data["firstName"];
    this.lastName = data["lastName"];
    this.userID = data["userID"];
    this.timestamp = data["timestamp"];
    this.details = data["details"];
    this.message = data["message"];
    this.id = id;
  }

}
